import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSEO } from "../hooks/useSEO";
import Countdown from "../components/Countdown";

export default function Ceremonie() {
  const [ceremony, setCeremony] = useState(null);
  const [loading, setLoading] = useState(true);

  useSEO("Cérémonie", "Retrouvez toutes les informations sur la cérémonie de remise des trophées Le Stand d'Or.");

  useEffect(() => {
    api.get("/ceremony")
      .then(({ data }) => setCeremony(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const ceremonyDate = ceremony?.date_iso ? new Date(ceremony.date_iso) : null;
  const isPast = ceremonyDate && ceremonyDate < new Date();

  if (loading) {
    return (
      <div className="pt-[140px] pb-40 max-w-[1300px] mx-auto px-6 lg:px-12">
        <p className="label" style={{ color: "#A1A1AA" }}>Chargement…</p>
      </div>
    );
  }

  return (
    <div className="pt-[140px] pb-40 max-w-[1300px] mx-auto px-6 lg:px-12">
      <p className="label mb-8" style={{ color: "#C9A961" }}>
        {ceremony?.edition ? `Édition ${ceremony.edition}` : "Le Stand d'Or"}
      </p>
      <h1
        className="font-serif mb-20"
        style={{ fontSize: "clamp(56px, 9vw, 140px)", lineHeight: 0.9, letterSpacing: "-0.025em", color: "#F8F6F0" }}
      >
        La<br />cérémonie.
      </h1>

      <div className="hairline mb-20" />

      {ceremony && ceremonyDate ? (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-20">
          {/* Infos */}
          <div className="md:col-span-5 space-y-12">
            <div>
              <p className="label mb-3" style={{ color: "#A1A1AA" }}>Date</p>
              <p className="font-serif" style={{ fontSize: 28, color: "#F8F6F0" }}>
                {ceremonyDate.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
              </p>
              <p className="label mt-2" style={{ color: "#C9A961" }}>
                {ceremonyDate.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}
              </p>
            </div>

            {(ceremony.venue || ceremony.city) && (
              <div>
                <p className="label mb-3" style={{ color: "#A1A1AA" }}>Lieu</p>
                {ceremony.venue && (
                  <p className="font-serif" style={{ fontSize: 24, color: "#F8F6F0" }}>{ceremony.venue}</p>
                )}
                {ceremony.city && (
                  <p className="label mt-1" style={{ color: ceremony.venue ? "#A1A1AA" : "#F8F6F0", fontSize: ceremony.venue ? undefined : 24, fontFamily: ceremony.venue ? undefined : "var(--font-serif, Georgia, serif)" }}>{ceremony.city}</p>
                )}
              </div>
            )}

            {ceremony.broadcast_platform && (
              <div>
                <p className="label mb-3" style={{ color: "#A1A1AA" }}>Diffusion</p>
                {ceremony.broadcast_url ? (
                  <a
                    href={ceremony.broadcast_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-serif"
                    style={{ fontSize: 22, color: "#C9A961", borderBottom: "1px solid #C9A961", paddingBottom: 2 }}
                  >
                    {ceremony.broadcast_platform}
                  </a>
                ) : (
                  <p className="font-serif" style={{ fontSize: 22, color: "#F8F6F0" }}>{ceremony.broadcast_platform}</p>
                )}
              </div>
            )}
          </div>

          {/* Compte à rebours */}
          <div className="md:col-span-7">
            {!isPast ? (
              <>
                <p className="label mb-10" style={{ color: "#A1A1AA" }}>Temps restant avant la cérémonie</p>
                <Countdown targetIso={ceremony.date_iso} />
              </>
            ) : (
              <div>
                <p className="label mb-6" style={{ color: "#C9A961" }}>Cérémonie passée</p>
                <p style={{ color: "rgba(248,246,240,0.7)", fontSize: 18, lineHeight: 1.8 }}>
                  La cérémonie a eu lieu. Retrouvez le palmarès dans la section Trophées.
                </p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={{ maxWidth: 600 }}>
          <p style={{ color: "rgba(248,246,240,0.6)", fontSize: 18, lineHeight: 1.8 }}>
            Les détails de la prochaine cérémonie seront annoncés prochainement.
            Inscrivez-vous à la lettre pour être informé·e en avant-première.
          </p>
        </div>
      )}
    </div>
  );
}
